module.exports = __webpack_public_path__ + "img/mobile-screen.b8ec30bb.svg";